import { render, staticRenderFns } from "./media-modal.vue?vue&type=template&id=79b063fc&"
import script from "./media-modal.vue?vue&type=script&lang=js&"
export * from "./media-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports